import { saveStateSlice } from './savestate-slice'

export const { closeDialog, openDialog, setSaveState } = saveStateSlice.actions
